import { render } from "./ProductCategory.vue?vue&type=template&id=1d7e6fa4&scoped=true"
import script from "./ProductCategory.vue?vue&type=script&lang=js"
export * from "./ProductCategory.vue?vue&type=script&lang=js"

import "./ProductCategory.vue?vue&type=style&index=0&id=1d7e6fa4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7e6fa4"]])

export default __exports__